import { Component, OnChanges, OnInit, input, inject } from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { NestedTreeControl } from '@angular/cdk/tree';
import { HttpErrorResponse } from '@angular/common/http';
import {
  ContentItem,
  ContentTreeItem,
  ContentType,
} from '@nimmsta/ng-commons-lib/models';
import { ContentsService } from '@nimmsta/ng-commons-lib/services/contents';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-information-folder',
  templateUrl: './information-folder.component.html',
  styleUrls: ['./information-folder.component.scss'],
  imports: [
    TranslatePipe,
    RouterLink,
  ],
})
export class InformationFolderComponent implements OnInit, OnChanges {
  private contentsService = inject(ContentsService);

  parent = input<ContentItem | undefined>();

  treeControl = new NestedTreeControl<ContentTreeItem>((node) => node.children);

  dataSource = new MatTreeNestedDataSource<ContentTreeItem>();

  isFolder = (_: number, node: ContentTreeItem) => node.type === ContentType.FOLDER;

  error?: HttpErrorResponse;

  tree: ContentTreeItem[] = [];

  ngOnInit() {
    this.load();
  }

  ngOnChanges() {
    this.load();
  }

  private load() {
    const parent = this.parent();
    if (parent) {
      this.contentsService.getTreeOfParent(parent.id).subscribe({
        next: (tree) => {
          this.dataSource.data = tree || [];
          this.tree = tree || [];
        },
        error: (error) => {
          this.error = error;
        },
      });
    } else {
      this.contentsService.getTree().subscribe({
        next: (tree) => {
          this.dataSource.data = tree || [];
          this.tree = tree || [];
        },
        error: (error) => {
          this.error = error;
        },
      });
    }
  }

  protected readonly ContentType = ContentType;
}
